module.exports = __webpack_public_path__ + "static/media/shop-purple-triangle-divider.dce6de0d.png";